import { useEffect, useMemo } from "react";
import { throttle } from "lodash";

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

export function useThrottledOnScroll(
  callback: (() => void) | null,
  delay: number
) {
  const throttledCallback = useMemo(
    () => (callback ? throttle(callback, delay) : noop),
    [callback, delay]
  );

  useEffect(() => {
    if (throttledCallback === noop) return undefined;
    const scrollMainContent = document.getElementById("main-content");

    scrollMainContent?.addEventListener("scroll", throttledCallback);
    return () => {
      scrollMainContent.removeEventListener("scroll", throttledCallback);
      // throttledCallback.cancel();
    };
  }, [throttledCallback]);
}
